<script lang="ts">
  import { onMount } from 'svelte';
  import { Button, Icon, TextField } from 'svelte-materialify';
  import { replace } from 'svelte-spa-router';
  import { AuthService } from '../../modules';
  import { user } from '../../store';

  let showPassword = false;
  let email = '';
  let password = '';

  onMount(onLoginMounted);

  async function loginUser() {
    try {
      await AuthService.login(email, password);
      window.location.replace('/');
    } catch (error) {
      alert(error.message);
    }
  }

  function onLoginMounted() {
    if ($user) {
      replace('/');
    }
  }
</script>

<div class="login">
  <h1 class="text-h2 mb-6">DailyReports</h1>
  <form on:submit|preventDefault>
    <TextField class="mb-3" bind:value={email} outlined>Email</TextField>
    <TextField
      class="mb-3"
      outlined
      type={showPassword ? 'text' : 'password'}
      bind:value={password}
    >
      Password
      <div
        slot="append"
        on:click={() => {
          showPassword = !showPassword;
        }}
      >
        <Icon class="mdi mdi-{showPassword ? 'eye-off' : 'eye'}" />
      </div>
    </TextField>
    <Button type="submit" class="primary-color float-right" on:click={loginUser}
      >Login</Button
    >
  </form>
</div>

<style lang="scss">
  .login {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 80px;
    justify-content: center;
    text-align: center;
    max-width: 560px;
    margin: 0 auto;
  }
</style>
